import AutoMationSms from 'components/AutoMationSms';
import InputOutlet from 'components/inputOutlet';
import DotsLoading from 'components/loadings/dotsLoading';
import {useFormik} from 'formik';
import {useEffect} from 'react';
import {Link, useLocation} from 'react-router-dom';
import useCountDown from 'utilities/hooks/countDown/useCountDown';
import {toEnglishDigits} from '../../../utilities/helper/toEnglishNumber';
import {CodeSchema} from '../login/utilities/loginSchema/codeSchema';
import UseSendCode from './hooks/useSendCode';
import UseSendConfirmation from './hooks/useSendConfirmation';

const LoginConfirmation = () => {
  const location = useLocation();
  const mobile = location.state?.mobile;

  const {currentMinutes, currentSeconds, startHandler, isRunning} =
    useCountDown();
  const {mutate, isLoading: isConfirmationLoading} = UseSendConfirmation();
  const {isLoading: sendCodeLoading, mutate: sendCodeMutate} = UseSendCode();

  useEffect(() => {
    startHandler();
  }, [startHandler]);

  const sendCode = () => {
    sendCodeMutate({mobile: mobile, app: 'market', country_code: '98'});
    startHandler();
  };

  const formik = useFormik({
    initialValues: {code: ''},
    validationSchema: CodeSchema,
    onSubmit: async values => {
      mutate({
        otp_code: values.code,
        app: 'market',
        country_code: '98',
        mobile,
      });
    },
  });

  useEffect(() => {
    const autoSubmitIfValid = async () => {
      if (formik.values.code.length === 5 && !formik.isSubmitting) {
        const errors = await formik.validateForm();
        if (!errors.code) {
          formik.submitForm();
        }
      }
    };
    autoSubmitIfValid();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.code]);

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formattedCode = toEnglishDigits(e.target.value).replace(/\D/g, '');
    if (formattedCode.length > 5) return;
    formik.setFieldValue('code', formattedCode, true);
  };
  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <AutoMationSms
          value={formik.values.code}
          setFieldValue={formik.setFieldValue}
          validateField={formik.validateField}
        />
        <div className="flex flex-col gap-4 text-center" dir="rtl">
          <InputOutlet
            label="شماره تلفن"
            name="phoneNumber"
            type="number"
            required
            showStar={false}
            value={mobile}
            disabled
          />

          <InputOutlet
            label="کد تایید"
            name="code"
            type="tel"
            autoComplete="one-time-code"
            inputMode="numeric"
            required
            dir="rtl"
            showStar={false}
            value={formik.values.code}
            onBlur={formik.handleBlur}
            touched={!!formik.touched.code}
            disabled={isConfirmationLoading}
            errors={formik.errors.code?.toString()}
            onChange={handleChangeInput}
          />

          <div className="flex items-center justify-between w-full mt-5 text-sm text-center tex-gray-6 text-gray-3">
            {isRunning ? (
              <div className="flex items-center justify-between gap-1 w-42">
                <span className="text-center ps-2 text-gray-3">
                  ارسال کد مجدد تا{' '}
                </span>
                <span className="inline-block text-center text-gray-700 max-w-8">
                  {currentMinutes}:{currentSeconds}
                </span>
              </div>
            ) : (
              <>
                {sendCodeLoading ? (
                  <DotsLoading />
                ) : (
                  <div className="flex items-center justify-between gap-2 w-42">
                    <u onClick={sendCode} className="no-underline text-cyan-2">
                      ارسال کد مجدد تا{' '}
                    </u>
                    <span>تا</span>
                    <span className="inline-block text-center text-gray-700 max-w-8">
                      00:00
                    </span>
                  </div>
                )}
              </>
            )}
            <Link
              to="/auth/login"
              className="bg-[#EDFBF8] text-[#22A68F] px-2 py-0.5 rounded-xl"
            >
              تغییر شماره
            </Link>
          </div>
        </div>
        {isConfirmationLoading && (
          <div className="mt-10 ">
            <DotsLoading />
          </div>
        )}
      </form>
    </>
  );
};

export default LoginConfirmation;
